<template>
    <div id="app">
        <!-- 导航栏 -->
        <div class="sys-nav-ctn" v-show="IsShowBar">
            <div class="flex" @click="gotoHome">
                <div class="sys-title font-lg">
                    <img :src="EntpLogo ? EntpLogo : '/img/icons/logo.png'" alt="" />
                    <span>{{ EntpName ? EntpName : '车回佳' }}</span>
                    <div class="timeLimit" v-if="HadRecord">
                        <span v-if="IsExpired">已过期</span>
                        <span v-else-if="ExpireDate">温馨提示：因欠费，系统将在 {{ ExpireDate }} 关闭！请尽快缴费！谢谢！</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="baberrage">
            <vue-baberrage :boxHeight="barrageBoxHeight" :isShow="barrageIsShow" :barrageList="barrageList" :loop="barrageLoop"></vue-baberrage>
        </div>
        <router-view />
        <div class="footer" v-if="showFooter">
            <span>&copy; 2018-2019 广州车回佳科技有限公司</span>
            <a href="http://www.chehuijia.com.cn/" target="_blank" title="车回佳">车回佳</a>
            <a href="http://www.beian.miit.gov.cn" target="_blank" title="粤ICP备18137855号-1">粤ICP备18137855号-1</a>
        </div>
    </div>
</template>
<script>
import { MESSAGE_TYPE } from 'vue-baberrage';
export default {
    name: 'app',
    components: {},
    data() {
        return {
            barrageBoxHeight: 300,
            barrageIsShow: true,
            currentId: 0,
            barrageLoop: false,
            barrageList: [],
            identity: '1', // 切换身份
            EntpName: '',
            EntpLogo: '',
            HadRecord: false,
            IsExpired: false,
            ExpireDate: '',
            userMsg: this.$util.getLocalStorage('userMsg'),
            IsShowBar: true
        };
    },
    mounted() {
        // this.addToList('测试弹幕')
        // this.$nextTick(() => {
        //   this.readUserMsg();
        // });

        //统计的代码
        this.$util.fnStatistics();
    },
    // 监听,当路由发生变化的时候执行
    watch: {
        $route(to, from) {
            this.readUserMsg();
            if (to.path === '/screen') this.IsShowBar = false;
            if (to.path === '/zoneOrder') this.IsShowBar = false;
            if (to.path === '/allOrder') this.IsShowBar = false;
            //to , from 分别表示从哪跳转到哪，都是一个对象 //to.path( 表示的是要跳转到的路由的地址 eg: /home );

            //统计的代码
            //this.$util.fnStatistics();
        }
    },
    // created(){
    //     this.getUserOrg();
    // },
    computed: {
        showFooter() {
            return this.$route.path === '/login';
        }
    },
    methods: {
        addToList(msg) {
            this.barrageList.push({
                id: ++this.currentId,
                avatar: '',
                msg: msg,
                time: 5,
                type: MESSAGE_TYPE.NORMAL
            });
        },
        // 跳转首页
        gotoHome() {
            if (this.$util.getLocalStorage('userMsg')) {
                this.$router.push('/');
            } else {
                this.$router.push('/login');
            }
        },
        // 读取用户信息
        readUserMsg() {
            let _userMsg = this.$util.getLocalStorage('userMsg');
            if (_userMsg) {
                this.EntpName = _userMsg.EntpName;
                this.EntpLogo = _userMsg.EntpLogo ? this.$util.QN_URL_BASE + _userMsg.EntpLogo : '/img/icons/logo.png';
                this.HadRecord = _userMsg.HadRecord;
                this.IsExpired = _userMsg.IsExpired;
                this.ExpireDate = _userMsg.ExpireDate;
            } else {
                this.EntpName = '车回佳';
                this.EntpLogo = '/img/icons/logo.png';
                this.HadRecord = false;
                this.IsExpired = false;
                this.ExpireDate = '';
            }
        },
        ///查看配置是否开始部门代替企业作为标题
        getUserOrg(){
            this.$util
                .axiosGet({
                    url: `/api/EntpInfoManagement/GetAcctOrg`
                })
                .then((res) => {
                    if(res.errcode == 0)
                        if(res.data)
                            this.EntpName = res.data;
                });
        }
    }
};
</script>
<style lang="less">
@import 'assets/css/common';
/*body {*/
/*    filter:grayscale(100%);*/
/*}*/
.baberrage {
    width: 100%;
    height: 300px;
    position: absolute;
    top: 45px;
    left: 0;
}
.baberrage-item {
    z-index: 9999;
}
.sys-title {
    cursor: pointer;
}
#app {
    height: inherit;
    background: white;
    min-width: 1200px;
}
.sys-nav-ctn {
    display: flex;
    justify-content: space-between;
    line-height: 45px;
    background: @bg1;
    color: white;
}

.sys-title {
    outline: 0px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    img {
        height: 30px;
        margin-right: 20px;
    }
}

.el-menu.el-menu--horizontal {
    border-bottom: none;
}

.identity-ctn {
    display: flex;
    align-items: center;
    .el-form-item {
        margin-bottom: 0;
    }
}
.loginCenter {
    margin: 0 20px;
    color: white;
    cursor: pointer;
}
.footer {
    a {
        width: auto;
        color: @font2Color;
        padding: 0 10px;
    }
    span {
        padding: 0 10px;
    }
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    line-height: 38px;
    height: 38px;
    background: @border3Color;
    z-index: 999;
}
.timeLimit {
    color: red;
    font-size: 14px;
    margin-left: 10px;
}
</style>
